import * as Yup from "yup";

const salesRepValidationSchema = Yup.object().shape({
  firstname: Yup.string().required("First Name is required"),
  lastname: Yup.string().required("Last Name is required"),
  branch: Yup.string().required("Branch is required"),
});

export default salesRepValidationSchema;
